 <section
    class="fixed inset-0 z-50 flex flex-col overflow-hidden bg-mock-blue-100"
    aria-modal="true"
    role="dialog"
    (click)="onBackdropClick()">
    @if (showTopBand) {
      <div class="h-10 bg-brand-primary"></div>
    }

    <div class="popup-layout-shell flex min-h-0 flex-1 justify-center overflow-y-auto thin-scrollbar px-4 py-8 sm:px-6">
      <img
        [src]="imageEnum.EMPTY_CORNER"
        alt=""
        class="popup-layout-corner pointer-events-none select-none"
        aria-hidden="true" />

      <div
        class="popup-layout-stage relative z-10 my-auto flex w-full shrink-0 items-center justify-center"
        (click)="$event.stopPropagation()">
        <ng-content></ng-content>
      </div>
    </div>
  </section>
